import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

const Benefits = (props) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="wpo-benefits-section">
      <h2 className="text-center">Saiba Mais</h2>
      <div className="row">
        <div className="col-lg-12 col-12">
          <div className="wpo-benefits-item">
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={""}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <h3>Executive Search / Hunting</h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className="fs-5">
                  Atuamos em diversos segmentos do mercado, buscando os melhores
                  profissionais com agilidade e precisão. O processo inclui
                  identificação, avaliação e encaminhamento de candidatos, além
                  de reuniões com a empresa para alinhamento de cultura e
                  necessidades.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={""}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <h3>Outplacement / Transição de Carreira</h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className="fs-5">
                  Desenvolvido de maneira personalizada e sigilosa, atendendo às
                  necessidades dos profissionais. Inclui análise de perfil,
                  definição de estratégias, desenvolvimento de currículo
                  profissional e do LinkedIn, treino de entrevista e assessoria
                  contínua.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                expandIcon={""}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <h3>Mentoria Executiva</h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className="fs-5">
                  <strong>Mentoria Individual:</strong> Potencializa o
                  desenvolvimento do colaborador, promovendo o alinhamento entre
                  suas competências e a cultura da empresa. <br />
                  <strong>Mentoria em Grupo:</strong> Estimula os participantes
                  a compreenderem seu papel coletivo e como suas interações
                  impactam os resultados organizacionais.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                expandIcon={""}
                aria-controls="panel4bh-content"
                id="panel4bh-header"
              >
                <h3>Palestras, Treinamentos e Workshops</h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className="fs-5">
                  Oferecemos soluções em educação corporativa para desenvolver
                  competências pessoais e profissionais, facilitando a adaptação
                  a mudanças e novos desafios através de palestras, treinamentos
                  e workshops.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
